var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8125 2.7983L5.02232 12.3925C5.95982 13.2586 8.4375 14.0625 10.8482 14.0625C13.2589 14.0625 15.7366 13.3919 16.6741 12.3925L19.2857 2.59842L15.0669 3.79769L10.8482 0L6.62943 3.79769L2.8125 2.7983ZM5.22322 6.2L10.8482 3.4L16.6741 6.2L15.0669 11.8L10.8482 12.8L6.83039 11.8L5.22322 6.2Z",
    fill: "#564ECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83931 9.2L6.83037 7.2L9.44193 6.8L10.8482 4L12.2544 6.8L15.0669 7.2L13.0581 9.2L13.2589 11.8L10.8482 10.8L8.63837 11.8L8.83931 9.2Z",
    fill: "#564ECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.2L1.40625 7.2L3.21429 9.2C3.41518 11.6 4.98214 16.44 9.64288 16.6L8.4375 18L9.04019 20C1.96875 18.56 0.0669644 12.2 0 9.2Z",
    fill: "#564ECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 9.2L20.4688 7.2L18.6607 9.2C18.4598 11.6 16.8929 16.44 12.2321 16.6L13.4375 18L12.8348 20C19.9063 18.56 21.8081 12.2 21.875 9.2Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketHub);
export default __webpack_public_path__ + "static/media/MarketHub.7f1afef73d26e18c2c9ebcc60221259d.svg";
export { ForwardRef as ReactComponent };